import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=b827d0ce&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=b827d0ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b827d0ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b827d0ce')) {
      api.createRecord('b827d0ce', component.options)
    } else {
      api.reload('b827d0ce', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=b827d0ce&scoped=true&", function () {
      api.rerender('b827d0ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25DDahK1afNj0/JS/comp/DateRange.vue"
export default component.exports